import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xl-12" }
const _hoisted_4 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_5 = { class: "panel-container show" }
const _hoisted_6 = { class: "panel-content contents" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-5 contCnt input-daterange input-group" }
const _hoisted_9 = {
  class: "input-daterange input-group",
  id: "datepicker-5"
}
const _hoisted_10 = { class: "col-md-5 contCnt selectedClear" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-5 contCnt" }
const _hoisted_13 = { class: "col-md-5 contCnt" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-xl-12" }
const _hoisted_18 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_19 = { class: "panel-container show" }
const _hoisted_20 = { class: "panel-content" }
const _hoisted_21 = {
  key: 0,
  class: "gtablecell"
}
const _hoisted_22 = {
  key: 1,
  class: "gtablecell"
}
const _hoisted_23 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mt_dtp = _resolveComponent("Mt_dtp")!
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _cache[22] || (_cache[22] = _createStaticVNode("<div class=\"row\" data-v-5ddc2282><div class=\"subheader col-6\" data-v-5ddc2282><h1 class=\"subheader-title\" data-v-5ddc2282>操作履歴一覧</h1></div><div class=\"subheader-block ml-auto demo\" data-v-5ddc2282><button type=\"button\" class=\"btn btn-primary waves-effect waves-themed\" data-v-5ddc2282><span class=\"fal fa-download mr-1\" data-v-5ddc2282></span>Excel出力 </button></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, "検索条件"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "操作日", -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Mt_dtp, {
                      contdate: _ctx.domOperationDay_start,
                      "onUpdate:contdate": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.domOperationDay_start) = $event)),
                      holidays: _ctx.delegate4list,
                      "onUpdate:holidays": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.delegate4list) = $event)),
                      class: "radius-1"
                    }, null, 8, ["contdate", "holidays"]),
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "input-group-append input-group-prepend input-group-joinner" }, [
                      _createElementVNode("span", { class: "input-group-text fs-xl" }, "－")
                    ], -1)),
                    _createVNode(_component_Mt_dtp, {
                      contdate: _ctx.domOperationDay_end,
                      "onUpdate:contdate": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.domOperationDay_end) = $event)),
                      holidays: _ctx.delegate4list,
                      "onUpdate:holidays": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.delegate4list) = $event)),
                      class: "radius-2"
                    }, null, 8, ["contdate", "holidays"])
                  ])
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "対象者", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.delegate4list.items4staffs,
                    label: "c_staff_name",
                    modelValue: _ctx.domStuff,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.domStuff) = $event)),
                    reduce: (label) => label.c_staff_id
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "案件番号", -1)),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtPjNo",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.domProjectNo) = $event)),
                    onKeydown: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.getlist(1)), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.domProjectNo]
                  ])
                ]),
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "請求No", -1)),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtClaimNo",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.domClaimNo) = $event)),
                    onKeydown: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.getlist(1)), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.domClaimNo]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary waves-effect waves-themed btn-search mx-auto",
                  disabled: _ctx.btnDisable,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getlist(1)))
                }, " 表示 ", 8, _hoisted_15)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, "条件結果"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_19, [
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_vue_good_table, {
                mode: "remote",
                onPageChange: _ctx.onPageChange,
                onSortChange: _ctx.onSortChange,
                columns: _ctx.columns,
                rows: _ctx.delegate.exitems,
                "sort-options": {
                  enabled: false,
                },
                "pagination-options": {
                  perPageDropdownEnabled: false,
                  enabled: true,
                  jumpFirstOrLast: true,
                  page: 1,
                  perPage: 10,
                  nextLabel: '次へ',
                  prevLabel: '前へ',
                  mode: 'pages',
                  ofLabel: '～',
                  pageLabel: '',
                },
                totalRows: _ctx.delegate.pager.maxcount
              }, {
                "table-row": _withCtx((props) => [
                  (props.column.field == 'c_history_datetime')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.cnvDate(props.formattedRow[props.column.field])), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(props.formattedRow[props.column.field]), 1))
                ]),
                _: 1
              }, 8, ["onPageChange", "onSortChange", "columns", "rows", "totalRows"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _cache[20] || (_cache[20] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => _cache[21] || (_cache[21] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("button", {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512)
  ]))
}